<mat-dialog-content>
    <div class="container">
        <div class="avatar-container">
            <img class="avatar"
                 [src]="user.avatar ? conf.storageRootUrl + user.avatar : conf.assetsUrl + 'img/avatar.png'"  alt="avatar"/>
        </div>
        <div class="name">{{ user.firstName + ' ' + user.lastName }}</div>
        <div class="legend">
            <span *ngFor="let role of roles; let i = index">{{ role.name }}<span *ngIf="i < roles.length - 1">, </span></span>
        </div>
        <div class="intro">{{ user.intro }}</div>
        <div *ngIf="userLinksData.length > 0" class="user-links">
            <a *ngFor="let userLinkData of userLinksData"
               href="{{ userLinkData.user_userLink.link }}"
               target="_blank"
               tabindex="-1"
               [matTooltip]="'Account_x' | translate:{account: userLinkData.userLink.name}"
               matTooltipPosition="left">
                <img src="{{ conf.assetsUrl + userLinkData.userLink.icon }}"  alt="{{userLinkData.userLink.name}}"/>
            </a>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <ng-container *ngIf="currentUser.isLoggedIn()">
        <button *ngIf="user.id !== currentUser.user?.id && !user.deleteDate"
                mat-button
                mat-dialog-close
                (click)="onDiscussClicked()">
            <mat-icon>message</mat-icon>&nbsp;{{ 'Discuss' | translate }}
        </button>
    </ng-container>
    <button mat-button
            mat-dialog-close>
        {{ 'Close' | translate}}
    </button>
</mat-dialog-actions>
